import { render, staticRenderFns } from "./RecruiterQaEntityText.vue?vue&type=template&id=3d98b83f&scoped=true"
import script from "./RecruiterQaEntityText.vue?vue&type=script&lang=js"
export * from "./RecruiterQaEntityText.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaEntityText.vue?vue&type=style&index=0&id=3d98b83f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98b83f",
  null
  
)

export default component.exports